import { useMemo } from 'react';
import { defineMessage, useIntl } from 'react-intl';

import { PhoneCode } from '@src-common/view/adapters/reactHookForm/PhoneField';

import { PHONE_CODES } from '../const/phone-codes';

const thresholdMsg = defineMessage({
  defaultMessage: 'It should have {threshold} characters',
  id: 'GHOOzU',
  description: 'Field validation message',
});

const usePhoneCodes = (): PhoneCode[] => {
  const intl = useIntl();

  const phoneCodes = useMemo(
    () =>
      PHONE_CODES.map(phoneCode => ({
        title: phoneCode.title,
        value: phoneCode.value,
        countryCode: phoneCode.countryCode,
        validationRules: {
          validate: (value: string) => {
            if (value.length === 0) {
              return;
            }

            if (phoneCode.validate !== undefined) {
              return phoneCode.validate(value, intl);
            }

            if (phoneCode.length === undefined || value.length === phoneCode.length) {
              return;
            }

            return intl.formatMessage(thresholdMsg, { threshold: phoneCode.length });
          },
        },
      })),
    [intl],
  );

  return phoneCodes;
};

export { usePhoneCodes };
